import { render, staticRenderFns } from "./create-collectionCode.vue?vue&type=template&id=520b27f6&"
import script from "./create-collectionCode.vue?vue&type=script&lang=ts&"
export * from "./create-collectionCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports